import Vue from 'vue'
import axios from 'axios'
// import notification from 'ant-design-vue/es/notification'
// const Mathnum = Math.floor(Math.random() * 2)
// const proxyMath = [
//   'http://172.16.110.5:8888/api',
//   'http://172.16.110.5:8882/api'
//   // 'http://172.16.110.5:8883/',
//   // 'http://172.16.110.5:8884/',
//   // 'http://172.16.110.5:8885/',
//   // 'http://172.16.110.5:8886/',
//   // 'http://172.16.110.5:8887/',
// ]
// console.log('代理配置', proxyMath[Mathnum], Mathnum)
// import axiosRetry from 'axios-retry';
// 创建 axios 实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  baseURL: "https://aigcplatform.yunquetech.com", // api base_url
  timeout: 1000 * 60 * 60, // 请求超时时间
  withCredentials: true,
  changeOrigin: true,
})
// axiosRetry(axios, {
//   retries: 5,                       // 设置自动发送请求次数
//   // retryDelay: (retryCount) => {
//   //   console.log(retryCount)
//   //   return retryCount * 1000;      // 重复请求延迟
//   // },
//   // shouldResetTimeout: true,       //  重置超时时间
//   // retryCondition: (error) => {
//   //   console.log(error)

//   //   //true为打开自动发送请求，false为关闭自动发送请求
//   //   if (error.message.includes("timeout")||error.message.includes("404")) {
//   //     return true;
//   //   } else {
//   //     return false;
//   //   };
//   // }
// });
//设置全局的请求次数，请求的间隙
// service.defaults.retry = 3; // 请求次数
service.defaults.retryDelay = 2000 //请求间隙

const errInfoModalkey = 'errInfoModalkey'

const CancelToken = axios.CancelToken

// Vue.prototype.$ac = [] // 全局定义一个存放取消请求的标识

const err = error => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
    //   notification.error({
    //     message: 'Forbidden',
    //     description: data.message
    //   })
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: '登陆状态失效'
    //   })
    }
  }
  // console.log(error.config)
  return Promise.reject(error)
}
// 请求中间键
service.interceptors.request.use(config => {
  // console.log(config)
  // if (config.RequestBaseurl) {
  //   const Mathnum = Math.floor(Math.random() * 2)
  //   const proxyMath = [
  //     'http://172.16.110.5:8888/api/',
  //     'http://172.16.110.5:8888/api/'
  //   ]
  //   ;(config.baseURL = proxyMath[Mathnum]), Mathnum
    // config.baseURL='http://172.16.110.5:8888/api/'
    // console.log('代理配置', proxyMath[Mathnum], Mathnum,config.devServer)
  // }

  if (config.cancel) {
    config.CancelToken = new CancelToken(c => {
      Vue.prototype.$ac.push({ u: config.url + '&' + config.method, f: c })
    })
  }
  return config
}, err)
// 响应中间键
service.interceptors.response.use(response => {
  // console.log('返回的东西',response);
  if (response.data.error) {
    alert(`错误提示：${response.data.data}`)
    // notification.error({
    //   key: errInfoModalkey,
    //   message: '出错了！',
    //   description: `错误提示：${response.data.data}`
    // })
    // eslint-disable-next-line no-throw-literal
    throw false
  }
  return response.data
}, err)

service.interceptors.response.use(undefined, function axiosRetryInterceptor(
  err
) {
  // console.log(err)
  // console.log(err.config)
  var config = err.config
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err)

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err)
  }

  // Increase the retry count
  config.__retryCount += 1

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve()
    }, config.retryDelay || 1)
  })

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function() {
    return axios(config)
  })
})

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }
